import React, { Component } from 'react';
import { Container, Button, Form, FormGroup, Input, FormFeedback, Row, Col, CardHeader, Card, ListGroup, ListGroupItem, CardBody, Modal, ModalHeader, ModalBody, CardLink, Media } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch' 
import { toast } from 'react-toastify';
import validaciones from '../../Auxiliares/validaciones'
import ReactFileReader from 'react-file-reader'
import SideBar from '../../Img/SideBar.png'
import Return from '../../Img/Regresar.png'

export default class Digitalizar extends Component {
    constructor(state) {
        super(state);
        this.state = {
            //vista
            contenido: '',
            
            //Fetch
            documentos: [],
            modulos: [],
            datosEstudiante: [],
            
            noControl: sessionStorage.getItem('fromConsulta') ? sessionStorage.getItem('fromConsulta') : '',
            tituloLista: '',
            files: [],
            select_documento_estado: false,
            usuario: sessionStorage.getItem('usuario'),
            errors: {},

            openModal: false,
            eliminarModal: false
        }
        this.buscarEstudiante = this.buscarEstudiante.bind(this)
        this.unDocumento = this.unDocumento.bind(this)
        this.multiDocumentos = this.multiDocumentos.bind(this)
        this.eliminarArchivo = this.eliminarArchivo.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.toggleEliminar = this.toggleEliminar.bind(this)
        this.cargarDragAndDrop = this.cargarDragAndDrop.bind(this)
        this.setModulo = this.setModulo.bind(this)
        this.submitDocumento = this.submitDocumento.bind(this)
    }

    toggleModal() {
        this.setState(prevState => ({
            openModal: !prevState.openModal
        }))
    }

    toggleEliminar() {
        this.setState(prevState => ({
            eliminarModal: !prevState.eliminarModal
        }))
    }

    componentDidMount() {
        Fetch('/api/getDocs', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ documentos: response.data })
                this.setState({ comboboxUnDocumento: response.data[0].doc })
            })
            .catch(err => {
                switch (err.status) {
                    case 602:
                        toast.error('Datos no encontrados')
                        break;
                    case 605:
                        toast.info('Listado de documentos vacia')
                        break;
                    default:
                        toast.error("Se produjo un error de conexion")
                        break;
                }
            })

        Fetch('/api/getModulos', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ modulos: response.data })
            })
            .catch(err => {
                switch (err.status) {
                    case 602:
                        toast.error('Datos no encontrados')
                        break;
                    case 605:
                        toast.info('Listado de documentos vacia')
                        break;
                    default:
                        toast.error("Se produjo un error de conexion")
                        break;
                }
            })

        if (sessionStorage.getItem("fromConsulta")) {
            this.setState({ noControl: localStorage.getItem("fromConsulta") })
        }
    }

    eliminarArchivo(index){
        let newArray = delete this.state.files[index]
        this.setState({ files: newArray })
    }

    setModulo(modulo) {
        this.setState({ tituloLista: modulo.lista })
        this.cargarDragAndDrop();
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                case 'noControl':
                    if (validaciones.validar_noControl(this.state.noControl)) {
                        value = validaciones.validar_noControl(this.state.noControl)
                        this.setState(prevState => ({ errors: { ...prevState.errors, noControl: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).noControl) });
                    }
                    break;

                case 'tituloLista':
                    this.setState({ select_documento_estado: true})
                    break;

                default:
                    break;
            }
        })
    }

    buscarEstudiante(e) {
        e.preventDefault();
        if(!this.state.errors.noControl){
        Fetch('/api/consultarUno', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ noControl: this.state.noControl })
        })
            .then(response => {
                this.setState({ datosEstudiante: response.data })
                this.setState({ contenido: (
                <Row>
                    <Col xs="12" md="6" >
                        <Button className="list-group-item w-100"
                        style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center', 
                        height: '75px', fontSize: '20px', marginBottom:'5px' }} 
                        onClick={this.unDocumento}>Un documento</Button>
                    </Col>
                    <Col xs="12" md="6">
                        <Button className="list-group-item w-100" 
                        style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center', 
                        height: '75px', fontSize: '20px', marginBottom:'5px' }} 
                        onClick={this.multiDocumentos}>Múltiples documentos</Button>
                    </Col>
                </Row>) })
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Error inesperado')
                        break;
                    case 605:
                        toast.info('No existen coincidencias')
                        break;
                    default:
                        toast.error("Se produjo un error de conexion")
                        break;
                }
            })
        }
    }

    handleFile = (files) => {
        this.setState({ files: [files.base64] })
    }

    handleFiles = (files) => {
        this.setState({ files: files.base64 })
    }

    unDocumento() {
        this.setState({
            contenido: (
            <div>
            <Row>
                <Col xs="12" className="text-left">
                    <Button onClick={this.buscarEstudiante} className="list-group-item"
                    style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}
                    >
                        <Media object src={Return} style={{maxHeigth:'2em', maxWidth:'2em'}}/>
                    </Button>
                </Col>   
            </Row>
            <br/>
            <Row className="text-center"  style={{display: 'flex', justifyContent:'center', alignItems:'center' }}>
                <div>
                <br/>
                <Col xs="12">
                    <Card className="text-center mx-auto my-auto">
                        <div className="mx-5">
                            <div> 
                            <FormGroup>
                                <Input type="select" className="w-100 mt-3" name="documento" id="documento" onChange={this.setValue.bind(this, "tituloLista")} ><option> </option>{this.state.documentos.length !== 0 ? this.state.documentos.map((index) => (<option>{index.doc}</option>)) : <div></div>}</Input>
                            </FormGroup>
                            
                            <FormGroup className="mt-3">
                                <ReactFileReader fileTypes={[".pdf"]} base64={true} multipleFiles={false} handleFiles={this.handleFile} >
                                    <button className='list-group-item btn btn-primary'
                                    style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}
                                    >Seleccionar documento</button>
                                </ReactFileReader>
                            </FormGroup>

                            <FormGroup>
                                <Button className="list-group-item btn btn-secondary w-100" onClick={this.submitDocumento}
                                style={{backgroundColor:'black'}}
                                >Subir</Button>
                            </FormGroup>
                        </div>
                        </div>
                    </Card>
                </Col>
                </div>
            </Row></div>)
        })
    }

    submitDocumento(e){
        e.preventDefault()

        const { noControl, files, tituloLista, usuario } = this.state
       
        Fetch('/api/addDocumento', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ file:files, noControl, documento: tituloLista, usuario })
        })
            .then(response => {
                toast.success('Documento en espera de validacion') 
                this.setState({ contenido: '', noControl: '', datosEstudiante: '', files: [] })   
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Error inesperado')
                        break;
                    case 601:
                        toast.error('Este documento ya existe')
                        break;
                    case 605:
                        toast.info('No existen coincidencias')
                        break;
                    default:
                        toast.error("Se produjo un error de conexion"+err)
                        console.log(err)
                        break;
                }
            })
    }

    multiDocumentos() {
        this.setState({
            contenido: (
                <Row>
                    <Col xs="12" className="text-left">
                        <Button onClick={this.buscarEstudiante} className="list-group-item"
                        style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}
                        >
                            <Media object src={Return} style={{maxHeigth:'2em', maxWidth:'2em'}}/>
                        </Button>
                    </Col>
                    <br/>
                    {this.state.modulos.length > 0 ? this.state.modulos.map((index) => (<Col xl="4" md="6" xs="12" className="list-group-item">
                        <Card onClick={() => this.setModulo(index)} className="clicable">
                            <CardHeader>
                                <Row>
                                    <Col className="col-12 align-self-center">{index.nombre}</Col>
                                </Row>
                            </CardHeader>

                            <CardBody className="text-left">
                                    {index.lista.map(
                                        (elemento) => (
                                            <div>
                                            <li style={{listStyle:'none'}}>{elemento}</li>
                                            <hr style={{color:'black'}}/>    
                                            </div>
                                        )
                                    )}
                            </CardBody>
                        </Card>
                    </Col>)) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col>}
                </Row>
            )
        })
    }
    

    submitMultiDocumentos(){
        const { noControl, files, tituloLista, usuario } = this.state

        Fetch('/api/addDocumentos', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ files, noControl, lista: tituloLista, usuario })
        })
            .then(response => {
                toast.success('Documento en espera de validacion')
                this.setState({ contenido: '', noControl: '', datosEstudiante: '', files: [] })     
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Error inesperado')
                        break;
                    case 605:
                        toast.info('No existen coincidencias')
                        break;
                    default:
                        toast.error("Se produjo un error de conexion"+err)
                        console.log(err)
                        break;
                }
            })
    }

    cargarDragAndDrop() {
        this.setState
            ({
                contenido:
                    (
                        <div>
                        <Col xs="12" className="text-left">
                            <Button onClick={this.multiDocumentos} className="list-group-item"
                            style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}
                            >
                                <Media object src={Return} style={{maxHeigth:'2em', maxWidth:'2em'}}/>
                            </Button>
                        </Col> 
                        <br/> 
                        <Col xs="12">
                            <FormGroup
                            style={{display: 'flex', justifyContent:'center', alignItems:'center' }}
                            >
                                <ReactFileReader fileTypes={[".pdf"]} base64={true} multipleFiles={true} handleFiles={this.handleFiles} >
                                    <button className='list-group-item btn btn-primary'
                                    style={{background:`url(${SideBar})`, backgroundSize:'cover', backgroundPosition:'center'}}
                                    >Seleccionar documentos</button>
                                </ReactFileReader>
                            </FormGroup>

                            <Col style={{display: 'flex', justifyContent:'center', alignItems:'center' }}>
                            <Button 
                            className="list-group-item bg-dark" onClick={() => this.submitMultiDocumentos()}
                            style={{backgroundColor:'black'}}
                            >Guardar</Button>
                            </Col>
                        </Col>
                    </div>
                    )
            })
    }

    render() {
        var url = window.location.pathname;
        var partir = url.split('/');
        var id = partir[partir.length-1];
        if(partir[partir.length-1]!='digitalizar' && 
        partir[partir.length-1].length==8 && 
        partir[partir.length-1].match(/^[0-9]+$/) != null)
        this.state.noControl = id;
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="">
                            <div class="container-fluid">
                                <h1 class="mt-2 mb-2 text-center">Digitalizar</h1>
                                <div className="p-4">
                                    <Container className="px-5">
                                        <Row className="text-center" style={{display: 'flex', justifyContent:'center', alignItems:'center' }}>
                                            <Col md="6">
                                                Introduzca el Número de Control:
                                                <Row>
                                                    <Col className="col-8">
                                                        <Form onSubmit={this.buscarEstudiante}>
                                                            <FormGroup >
                                                                <Input type="text" style={{ height: '100%', width: '100%' }} onChange={this.setValue.bind(this, 'noControl')} invalid={this.state.errors.noControl} maxLength="8" value={this.state.noControl}></Input>
                                                                <FormFeedback>{this.state.errors.noControl}</FormFeedback>
                                                            </FormGroup>
                                                        </Form>
                                                    </Col>

                                                    <Col className="col-4">
                                                        <FormGroup style={{float:'right'}}>
                                                            <Input type="button" className="bg-info text-light" onClick={this.buscarEstudiante} value="Buscar" style={{width: '100%' }} />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3 mb-2">
                                            <Card className="text-center p-2" style={{ minHeight: '60px', width: '100%' }}>

                                                {this.state.datosEstudiante.length !== 0 ? (
                                                    <Card className="text-left p-3 border-0" style={{ width: '100%', minHeight: '60px', 
                                                    display: 'flex', justifyContent:'center', alignItems:'center' }}>
                                                        <Row style={{width:'100%'}}>
                                                            <Col className="font-weight-bold" xs="12" md="4">{">No. Control"}</Col> <Col md="8" xs="12">{this.props.encabezado ? "No. Control" : this.state.datosEstudiante.noControl}</Col>
                                                            <Col className="font-weight-bold" xs="12" md="4">{">Nombre"}</Col> <Col md="8" xs="12">{this.props.encabezado ? "Nombre" : this.state.datosEstudiante.nombre + ' ' + this.state.datosEstudiante.ap_paterno + ' ' + this.state.datosEstudiante.ap_materno}</Col>
                                                            <Col className="font-weight-bold" xs="12" md="4">{">Carrera"}</Col> <Col md="8" xs="12">{this.props.encabezado ? "Carrera" : this.state.datosEstudiante.carrera}</Col>
                                                            <Col className="font-weight-bold" xs="12" md="4">{">Semestre"}</Col>  <Col md="8" xs="12">{this.props.encabezado ? "Sem." : this.state.datosEstudiante.semestre}</Col>
                                                        </Row>
                                                    </Card>
                                                ) : (
                                                    <Card className="text-left p-3 border-0" style={{ width: '100%', minHeight: '60px', 
                                                    display: 'flex', justifyContent:'center', alignItems:'center' }}>
                                                        <Row style={{width:'100%'}}>
                                                            <Col className="font-weight-bold" xs="12" md="4">{">No. Control"}</Col>  <Col md="8" xs="12">{"?"}</Col>
                                                            <Col className="font-weight-bold" xs="12" md="4">{">Nombre"}</Col>  <Col md="8" xs="12">{"?"}</Col>
                                                            <Col className="font-weight-bold" xs="12" md="4">{">Carrera"}</Col>  <Col md="8" xs="12">{"?"}</Col>
                                                            <Col className="font-weight-bold" xs="12" md="4">{">Semestre"}</Col>  <Col md="8" xs="12">{"?"}</Col>
                                                        </Row>
                                                    </Card>
                                                )}
                                            </Card>
                                        </Row>

                                        <Row>
                                            <Card className="text-center p-3" style={{minHeight:'160px', width: '100%' }}>
                                                <Card className="mx-5 border-0 my-4">
                                                    {this.state.contenido}
                                                </Card>
                                            </Card>
                                        </Row>

                                        <Modal isOpen={this.state.openModal} toggle={() => this.toggleModal()} className="modal-sm">
                                            <ModalHeader></ModalHeader>
                                            <ModalBody>
                                                <div className="text-center">
                                                    <h4>Documentos agregados!</h4>
                                                </div>
                                            </ModalBody>
                                            <Button onClick={() => !this.toggleModal()}>Cerrar</Button>
                                        </Modal>

                                        <Modal isOpen={this.state.eliminarModal} toggle={() => this.toggleEliminar()} className="modal-sm">
                                            <ModalHeader></ModalHeader>
                                            <ModalBody>
                                                <div className="text-center">
                                                <h4>Eliminar documento </h4><h4 className="font-weight-bold">{this.state.eliminarModal}</h4>
                                                </div>
                                            </ModalBody>
                                            <CardLink className="text-center">
                                                <Button onClick={() => !this.eliminarArchivo(this.state.eliminarModal)}>Eliminar</Button>
                                                <Button onClick={() => !this.toggleModal()}>Cerrar</Button>
                                            </CardLink>
                                        </Modal>

                                    </Container>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Footer />
            </html>
        )
    }
}
